import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GungTableConfig } from 'gung-common';
import { first } from 'rxjs';
import { Customer } from '../../models';
import { CustomerActionConfigService } from '../../services/customer-action-config.service';
import { CustomerService } from '../../services/customers/customer.service';
import { SelectedCustomerService } from '../../services/selected-customer/selected-customer.service';
import { CustomerCustomTableBodyComponent } from './customer-custom-table-body/customer-custom-table-body.component';

@Component({
    selector: 'lib-customer-list-table',
    templateUrl: './customer-list-table.component.html',
    styleUrl: './customer-list-table.component.scss',
    standalone: false
})
export class CustomerListTableComponent {
  isLoading: boolean = true;

  public selectCustomerService = inject(SelectedCustomerService);
  protected customerService = inject(CustomerService);
  protected router = inject(Router);
  public actionButtonsConfig = inject(CustomerActionConfigService, { optional: true });

  config: GungTableConfig<Customer>;

  sort() {
    return (a, b) => a.customerId?.localeCompare(b.customerId);
  }

  sortName() {
    return (a, b) => a.name?.localeCompare(b.name);
  }

  ngOnInit() {
    this.customerService
      .getCustomers()
      .pipe(first())
      .subscribe(customers => {
        this.initTable(customers);
        this.isLoading = false;
      });
  }

  initTable(customers: Customer[]) {
    this.config = {
      data: customers,
      headers: [
        { name: 'ID', path: 'id', sortable: false, extraClass: 'd-none', searchable: true },
        { name: 'ID', path: 'extra.gme.displayId', sortable: true, searchable: true},
        { name: 'NAME', path: 'extra.gme.displayName', sortable: true, searchable: true, enableFilter: true },
        {
          name: 'ADDRESS',
          path: 'extra.gme.address.address1',
          sortable: true,
          searchable: true,
          enableFilter: false
        },
        { name: 'CITY', path: 'extra.gme.address.city', sortable: true, searchable: true, enableFilter: true },
        {
          name: 'COUNTRY',
          path: 'extra.gme.address.countryCode',
          sortable: true,
          searchable: true,
          enableFilter: true
        },
        {
          name: 'ORG_NR',
          path: 'extra.gme.billingAddress.organizationNumber',
          sortable: true,
          searchable: true,
          enableFilter: false
        },
        {
          name: '',
          path: null,
          sortable: false,
          searchable: false,
          enableFilter: false
        }
      ],
      title: 'CUSTOMERS',
      enableSearch: true,
      itemsPerPage: 15,
      useNumberPaginantion: false,
      customBodyComponent: CustomerCustomTableBodyComponent,
      useQueryParams: true
    };
  }

  selectCustomer(id) {
    this.router.navigate(['customers', id]);
    this.selectCustomerService.selectCustomer(id);
  }

  selectCustomerWithoutNavigate(id) {
    this.selectCustomerService.selectCustomer(id);
  }
}
